var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon6BlogBus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.64 13.8h0m10.09 0h0M11.68 1.24V9.4m-8.26.59h16.53",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.68 2c3.76 0 5.61.54 7.69 1.43v14.41c0 .24-.14.42-.33.42H4.33c-.18 0-.33-.18-.33-.42V3.44C6.07 2.53 7.93 2 11.68 2m0-2C7.71 0 5.57.58 3.21 1.6A2 2 0 0 0 2 3.42v14.41a2.38 2.38 0 0 0 2.33 2.42h14.71a2.38 2.38 0 0 0 2.33-2.42V3.44a2 2 0 0 0-1.21-1.85C17.8.6 15.66 0 11.68 0z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.16 19.89v3.1m-10.87-3.1v3.1"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPHBhdGggZD0iTTYuNjQgMTMuOGgwbTEwLjA5IDBoME0xMS42OCAxLjI0VjkuNG0tOC4yNi41OWgxNi41MyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPg0KICAgIDxwYXRoIGQ9Ik0xMS42OCAyYzMuNzYgMCA1LjYxLjU0IDcuNjkgMS40M3YxNC40MWMwIC4yNC0uMTQuNDItLjMzLjQySDQuMzNjLS4xOCAwLS4zMy0uMTgtLjMzLS40MlYzLjQ0QzYuMDcgMi41MyA3LjkzIDIgMTEuNjggMm0wLTJDNy43MSAwIDUuNTcuNTggMy4yMSAxLjZBMiAyIDAgMCAwIDIgMy40MnYxNC40MWEyLjM4IDIuMzggMCAwIDAgMi4zMyAyLjQyaDE0LjcxYTIuMzggMi4zOCAwIDAgMCAyLjMzLTIuNDJWMy40NGEyIDIgMCAwIDAtMS4yMS0xLjg1QzE3LjguNiAxNS42NiAwIDExLjY4IDB6IiBmaWxsPSIjMDAwIiAvPg0KICAgIDxwYXRoIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik0xNy4xNiAxOS44OXYzLjFtLTEwLjg3LTMuMXYzLjEiLz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { SvgIcon6BlogBus as ReactComponent };